// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__FOljj","tab":"ProcedureTabs_tab__2MR1g"};